import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Visibility from '@material-ui/icons/Visibility';
import DialogViewTransactions from '../../Dialogs/DialogViewTransactions';
import { useTranslation } from 'react-i18next';
import { useStyles } from 'components/layout/CommonStyles';
import { GetGeneralPermissionForAction } from 'utils/permissions/GetGeneralPermissionForAction';
import { Screen, Allow } from 'global/constants';
import { screenStyles } from '../../Styles';

const ExpensesTableActions = props => {
    if (localStorage.getItem('auth-token') !== null) {
        var auth = JSON.parse(localStorage.getItem('auth-token'));
    }
    const styles = screenStyles();
    const classes = useStyles();
    const [t] = useTranslation();
    const { item , isLSBD} = props;

    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <Tooltip
                title={t('GENERAL.view')}
                aria-label="details"
                placement="top"
            >
                <IconButton
                    className={classes.iconsTableActions}
                    onClick={() => setOpen(true)}
                >
                    <Visibility />
                </IconButton>
            </Tooltip>

            {open && (
                <DialogViewTransactions
                    open={open}
                    setOpen={setOpen}
                    viewValues={item}
                    isExpense={true}
                />
            )}
        </React.Fragment>
    );
};

export default ExpensesTableActions;
